import tools from 'utilities/tools';

export const bufferedSaveAddressInformation = ({ handleNextStep, handleSave, userProfileForm }, field, value) => {
    tools.aggregatedDebounce(() => {
        const isValid = userProfileForm[field] && userProfileForm[field].valid;

        const stuff =
            field !== 'address' && userProfileForm[field] && userProfileForm[field].valid ? { [field]: value } : {};
        const stuffHasLength = Object.keys(stuff).length > 0;
        stuffHasLength && handleSave('homeAddress', stuff);

        handleNextStep(isValid);
    }, 1000)({ handleNextStep, handleSave, userProfileForm }, field, value);
};
